<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="`${i}image-slideshows${index}`">
				<div v-if="i === 'background-image'">
					<BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template" />
				</div>
				<div v-else-if="i === 'slides'">
					<h5>Slides</h5>
					<Repeater
						v-if="getContentTemplate"
						:itemArray="componentItem.content"
						:itemField="i"
						:template="getContentTemplate.content.slides[0]"
						:componentTemplate="'image-slideshows'"
					/>
				</div>
				<div v-else-if="i === 'default-image'" class="form-group">
					<h5>{{ i }}</h5>
					<div v-for="(field, j) in content" :key="j">
						<div class="form-group">
							<label>{{ j }}</label>
							<input type="text" class="form-control" :id="j" v-model="content[j]" >
						</div>
					</div>
				</div>
				<div v-else-if="typeof content !== 'object'" class="form-group">
					<label>{{ i }}</label>
					<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
				</div>
				<BackgroundAudio :componentItemContent="componentItem.content" />
			</div>
		</template>
	</div>
</template>

<script>
	import BackgroundImage from '../BackgroundImage';
	import BackgroundAudio from '../BackgroundAudio';
	import Repeater from '../Repeater';

	export default {

		components: {
			BackgroundImage,
			Repeater,
			BackgroundAudio
		},
		
		name: 'ImageSlideshows',
		
		props: ['componentItem', 'index', 'componentTemplates'],

		data() {
			return {
				template: '',
				repeaterField: 'slides'
			}
		},

		mounted() {
		},

		computed:{
			getContentTemplate() {
				if(this.componentTemplates){
					return JSON.parse(JSON.stringify(
						this.componentTemplates.filter(item => item.template == 'image-slideshows')[0]
					));
				}else{
					return null
				}
			}
		},
		
	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>